// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { FreeMode, Navigation, Pagination } from 'swiper/modules';

function initializeProductSliders(root = document) {
  const sliders = [];

  if (root.matches?.('.slider-container .swiper')) {
    sliders.push(root);
  }
  sliders.push(...root.querySelectorAll('.slider-container .swiper'));

  sliders.forEach((slider) => {
    if (slider.classList.contains('swiper-initialized')) {
      return;
    }

    // Check if slider has data-attribute for slidesPerView
    const slidesPerView = slider.dataset.slidesperview ? parseFloat(slider.dataset.slidesperview) : 1.5;
    const slidesPerViewSM = slider.dataset.slidesperviewsm ? parseFloat(slider.dataset.slidesperviewsm) : 1.8;
    const slidesPerViewMD = slider.dataset.slidesperviewmd ? parseFloat(slider.dataset.slidesperviewmd) : 2.2;
    const slidesPerViewLG = slider.dataset.slidesperviewlg ? parseFloat(slider.dataset.slidesperviewlg) : 4.2;
    const slidesPerViewXL = slider.dataset.slidesperviewxl ? parseFloat(slider.dataset.slidesperviewxl) : slidesPerViewLG;
    const slidesPerViewXXL = slider.dataset.slidesperviewxxl ? parseFloat(slider.dataset.slidesperviewxxl) : slidesPerViewXL;

    const container = slider.closest('.slider-container');
    const alignStart = container.matches('.slider-align-start-wide, .slider-align-start-content');
    const heading = container.querySelector('.slider-heading');
    const updateSlideOffsets = (swiper) => {
      const headingStyle = heading ? getComputedStyle(heading) : null;
      swiper.params.slidesOffsetBefore = parseFloat(headingStyle?.paddingLeft) || 0;
      swiper.params.slidesOffsetAfter = parseFloat(headingStyle?.paddingRight) || 0;
    };

    new Swiper(slider, {
      modules: [FreeMode, Navigation, Pagination],
      ...(alignStart ? {
        on: {
          beforeInit: updateSlideOffsets,
          beforeResize: updateSlideOffsets,
        },
      } : {}),
      slidesPerView: slidesPerView,
      spaceBetween: 16,
      snapToSlideEdge: false,
      freeMode: {
        enabled: true,
        sticky: false,
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 4,
      },
        breakpoints: {
            560: { // sm
                slidesPerView: slidesPerViewSM,
            }, 
            768: { // md
                slidesPerView: slidesPerViewMD,
            },
            992: { // lg
                slidesPerView: slidesPerViewLG,
            },
            1200: { // xl
                slidesPerView: slidesPerViewXL,
            },
            1400: { // xxl
                slidesPerView: slidesPerViewXXL,
            },
        },
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeProductSliders(), { once: true });
} else {
  initializeProductSliders();
}

const sliderObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        initializeProductSliders(node);
      }
    });
  });
});
sliderObserver.observe(document.documentElement, { childList: true, subtree: true });